<ng-container *ngIf="projectSetPortfolio?.ownerOrganization?.id">
  <oes-developer-profile
    [id]="projectSetPortfolio.ownerOrganization.id">
  </oes-developer-profile>
</ng-container>
